import { Component, OnInit } from "@angular/core";
import { ServiceItem } from "src/app/model/model";

@Component({
  selector: "app-service-stats-and-test",
  templateUrl: "./service-stats-and-test.component.html",
  styleUrls: ["./service-stats-and-test.component.css"]
})
export class ServiceStatsAndTestComponent implements OnInit {

  constructor() {
    this.statsInvocations = 1234;
    this.statsRespTime = 1.2; }

  statsInvocations: number;
  // The response time is measured in seconds
  statsRespTime: number;

  serviceDetails: ServiceItem | undefined;

  ngOnInit(): void {
  }

}
